webpackJsonp([0],[
/* 0 */,
/* 1 */,
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(24),
  /* template */
  __webpack_require__(14),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 3 */,
/* 4 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 5 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__views_Layout__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__views_Layout___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__views_Layout__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__views_Login__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__views_Login___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__views_Login__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__views_requirement_Index__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__views_requirement_Index___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__views_requirement_Index__);







__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  mode: 'history',
  routes: [{
    name: 'Layout',
    component: __WEBPACK_IMPORTED_MODULE_2__views_Layout___default.a,
    path: '/',
    children: [{
      path: 'requirement',
      component: __WEBPACK_IMPORTED_MODULE_4__views_requirement_Index___default.a,
      name: 'Requirement'
    }, {
      path: 'production',
      component: __WEBPACK_IMPORTED_MODULE_4__views_requirement_Index___default.a,
      name: 'Production'
    }]
  }, {
    path: '/login',
    name: 'Login',
    component: __WEBPACK_IMPORTED_MODULE_3__views_Login___default.a
  }]
}));

/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/logo.d5ffccf.png";

/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(20)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(25),
  /* template */
  __webpack_require__(16),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(26),
  /* template */
  __webpack_require__(17),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 9 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(27),
  /* template */
  __webpack_require__(19),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 10 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(28),
  /* template */
  __webpack_require__(13),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 11 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(29),
  /* template */
  __webpack_require__(18),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 12 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(30),
  /* template */
  __webpack_require__(15),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 13 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('Form', {
    attrs: {
      "model": _vm.formItem,
      "label-width": 80
    }
  }, [_c('Row', [_c('Col', {
    attrs: {
      "span": "24"
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "需求名称"
    }
  }, [_c('Input', {
    attrs: {
      "placeholder": "请输入"
    },
    model: {
      value: (_vm.formItem.input),
      callback: function($$v) {
        _vm.formItem.input = $$v
      },
      expression: "formItem.input"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('Row', [_c('Col', {
    attrs: {
      "span": "8"
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "来源"
    }
  }, [_c('Select', {
    attrs: {
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.formItem.select),
      callback: function($$v) {
        _vm.formItem.select = $$v
      },
      expression: "formItem.select"
    }
  }, [_c('Option', {
    attrs: {
      "value": "beijing"
    }
  }, [_vm._v("北京市")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": "shanghai"
    }
  }, [_vm._v("上海市")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": "shenzhen"
    }
  }, [_vm._v("深圳市")])], 1)], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": "8"
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "等级"
    }
  }, [_c('Select', {
    attrs: {
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.formItem.select),
      callback: function($$v) {
        _vm.formItem.select = $$v
      },
      expression: "formItem.select"
    }
  }, [_c('Option', {
    attrs: {
      "value": "beijing"
    }
  }, [_vm._v("北京市")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": "shanghai"
    }
  }, [_vm._v("上海市")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": "shenzhen"
    }
  }, [_vm._v("深圳市")])], 1)], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": "8"
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "期望日期"
    }
  }, [_c('Date-picker', {
    staticClass: "full-width",
    attrs: {
      "type": "date",
      "placeholder": "选择日期"
    },
    model: {
      value: (_vm.formItem.date),
      callback: function($$v) {
        _vm.formItem.date = $$v
      },
      expression: "formItem.date"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('Row', [_c('Col', {
    attrs: {
      "span": "24"
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "背景说明"
    }
  }, [_c('Input', {
    attrs: {
      "type": "textarea",
      "rows": 4,
      "placeholder": "请输入"
    },
    model: {
      value: (_vm.formItem.input),
      callback: function($$v) {
        _vm.formItem.input = $$v
      },
      expression: "formItem.input"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('Row', [_c('Col', {
    attrs: {
      "span": "24"
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "研发答复"
    }
  }, [_c('Input', {
    attrs: {
      "type": "textarea",
      "rows": 4,
      "placeholder": "请输入"
    },
    model: {
      value: (_vm.formItem.input),
      callback: function($$v) {
        _vm.formItem.input = $$v
      },
      expression: "formItem.input"
    }
  })], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 14 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('router-view')], 1)
},staticRenderFns: []}

/***/ }),
/* 15 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('Form', {
    ref: "formInline",
    staticClass: "padding-blank no-margin-item",
    attrs: {
      "inline": "",
      "label-width": 40
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "名称"
    }
  }, [_c('Input', {
    staticClass: "normal-form-item",
    attrs: {
      "type": "text",
      "placeholder": "Username"
    }
  })], 1), _vm._v(" "), _c('Form-item', {
    attrs: {
      "label": "来源"
    }
  }, [_c('Select', {
    staticClass: "normal-form-item",
    model: {
      value: (_vm.model1),
      callback: function($$v) {
        _vm.model1 = $$v
      },
      expression: "model1"
    }
  }, _vm._l((_vm.cityList), function(item) {
    return _c('Option', {
      key: item.value,
      attrs: {
        "value": item.value
      }
    }, [_vm._v(_vm._s(item.label))])
  }))], 1), _vm._v(" "), _c('Form-item', {
    attrs: {
      "label": "状态"
    }
  }, [_c('Select', {
    staticClass: "normal-form-item",
    model: {
      value: (_vm.model1),
      callback: function($$v) {
        _vm.model1 = $$v
      },
      expression: "model1"
    }
  }, _vm._l((_vm.cityList), function(item) {
    return _c('Option', {
      key: item.value,
      attrs: {
        "value": item.value
      }
    }, [_vm._v(_vm._s(item.label))])
  }))], 1), _vm._v(" "), _c('Form-item', [_c('Button', {
    attrs: {
      "type": "primary",
      "icon": "ios-search"
    }
  }, [_vm._v("搜索")])], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 16 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "layout"
  }, [_c('Menu', {
    attrs: {
      "mode": "horizontal",
      "theme": "dark",
      "active-name": "1"
    },
    on: {
      "on-select": _vm.selected
    }
  }, [_c('div', {
    staticClass: "layout-logo"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(6),
      "alt": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "layout-nav"
  }, [_c('Menu-item', {
    attrs: {
      "name": "1"
    }
  }, [_c('Icon', {
    attrs: {
      "type": "ios-home"
    }
  }), _vm._v("\n        首页\n      ")], 1), _vm._v(" "), _c('Menu-item', {
    attrs: {
      "name": "2"
    }
  }, [_c('Icon', {
    attrs: {
      "type": "ios-paper"
    }
  }), _vm._v("\n        需求管理\n      ")], 1), _vm._v(" "), _c('Menu-item', {
    attrs: {
      "name": "3"
    }
  }, [_c('Icon', {
    attrs: {
      "type": "ios-keypad"
    }
  }), _vm._v("\n        产品管理\n      ")], 1), _vm._v(" "), _c('Menu-item', {
    attrs: {
      "name": "4"
    }
  }, [_c('Icon', {
    attrs: {
      "type": "person"
    }
  }), _vm._v("\n        人员管理\n      ")], 1), _vm._v(" "), _c('Menu-item', {
    attrs: {
      "name": "5"
    }
  }, [_c('Icon', {
    attrs: {
      "type": "person-stalker"
    }
  }), _vm._v("\n        角色管理\n      ")], 1), _vm._v(" "), _c('Submenu', {
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "name": "6"
    }
  }, [_c('template', {
    slot: "title"
  }, [_c('Icon', {
    attrs: {
      "type": "ios-gear"
    }
  }), _vm._v("\n          设置\n        ")], 1), _vm._v(" "), _c('Menu-item', {
    attrs: {
      "name": "61"
    }
  }, [_vm._v("修改密码")]), _vm._v(" "), _c('Menu-item', {
    attrs: {
      "name": "62"
    }
  }, [_vm._v("退出")])], 2), _vm._v(" "), _c('div', {
    staticClass: "user-name-bar"
  }, [_vm._v(_vm._s(_vm.userName) + "(" + _vm._s(_vm.userTrueName) + ")")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('router-view')], 1), _vm._v(" "), _c('footer', {
    staticClass: "layout-copy"
  }, [_vm._v("2011-2016 © 艾润物联")])], 1)
},staticRenderFns: []}

/***/ }),
/* 17 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "login"
  }, [_c('Row', {
    attrs: {
      "type": "flex",
      "justify": "center",
      "align": "middle"
    }
  }, [_c('Col', {
    staticClass: "form"
  }, [_c('h3', [_vm._v("停车王需求管理系统")]), _vm._v(" "), _c('Form', {
    ref: "loginForm",
    attrs: {
      "model": _vm.loginForm,
      "rules": _vm.loginRule
    }
  }, [_c('Form-item', {
    attrs: {
      "prop": "user"
    }
  }, [_c('Input', {
    attrs: {
      "type": "text",
      "placeholder": "请输入用户名"
    },
    model: {
      value: (_vm.loginForm.user),
      callback: function($$v) {
        _vm.loginForm.user = $$v
      },
      expression: "loginForm.user"
    }
  }, [_c('Icon', {
    attrs: {
      "type": "ios-person-outline"
    },
    slot: "prepend"
  })], 1)], 1), _vm._v(" "), _c('Form-item', {
    attrs: {
      "prop": "password"
    }
  }, [_c('Input', {
    attrs: {
      "type": "password",
      "placeholder": "请输入密码"
    },
    model: {
      value: (_vm.loginForm.password),
      callback: function($$v) {
        _vm.loginForm.password = $$v
      },
      expression: "loginForm.password"
    }
  }, [_c('Icon', {
    attrs: {
      "type": "ios-locked-outline"
    },
    slot: "prepend"
  })], 1)], 1), _vm._v(" "), _c('Form-item', [_c('Checkbox', {
    staticStyle: {
      "float": "left"
    },
    model: {
      value: (_vm.loginForm.remember),
      callback: function($$v) {
        _vm.loginForm.remember = $$v
      },
      expression: "loginForm.remember"
    }
  }, [_vm._v("记住密码")]), _vm._v(" "), _c('Button', {
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "type": "primary",
      "loading": _vm.loginLoading,
      "icon": "log-in"
    },
    on: {
      "click": function($event) {
        _vm.loginPost('loginForm')
      }
    }
  }, [_vm._v("登录\n          ")])], 1)], 1)], 1)], 1)], 1)])
},staticRenderFns: []}

/***/ }),
/* 18 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('Row', {
    staticClass: "padding-blank"
  }, [_c('h3', {
    staticClass: "all-title"
  }, [_vm._v("需求列表"), _c('Button', {
    staticClass: "float-right",
    attrs: {
      "type": "success",
      "icon": "android-add"
    }
  }, [_vm._v("添加")])], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": "24"
    }
  }, [_c('Table', {
    attrs: {
      "data": _vm.tableData1,
      "columns": _vm.tableColumns1,
      "stripe": ""
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin": "10px",
      "overflow": "hidden"
    }
  }, [_c('div', {
    staticStyle: {
      "float": "right"
    }
  }, [_c('Page', {
    attrs: {
      "total": 100,
      "current": 1
    },
    on: {
      "on-change": _vm.changePage
    }
  })], 1)])], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 19 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('Query'), _vm._v(" "), _c('List'), _vm._v(" "), _c('Modal', {
    attrs: {
      "width": "1000",
      "title": "添加需求",
      "class-name": "vertical-center-modal"
    },
    model: {
      value: (_vm.modal10),
      callback: function($$v) {
        _vm.modal10 = $$v
      },
      expression: "modal10"
    }
  }, [_c('Add')], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 20 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 21 */,
/* 22 */,
/* 23 */,
/* 24 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'app'
});

/***/ }),
/* 25 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  created: function created() {},
  data: function data() {
    return {
      //用户信息
      userName: 'admin',
      userTrueName: '丁东阳'
    };
  },

  methods: {
    selected: function selected(name) {
      var routers = [];
      routers[1] = 'Requirement';
      routers[2] = 'Production';
      routers[62] = 'Login';
      if (name == 1) {
        this.index = true;
      } else {
        this.index = false;
      }
      this.$router.push({ 'name': routers[name] });
    }
  }
});

/***/ }),
/* 26 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      loginForm: {
        user: '',
        password: '',
        remember: true
      },
      loginRule: {
        user: [{ required: true, message: '请填写用户名', trigger: 'blur' }],
        password: [{ required: true, message: '请填写密码', trigger: 'blur' }, { type: 'string', min: 6, message: '密码长度不能小于6位', trigger: 'blur' }]
      },
      loginLoading: false
    };
  },

  methods: {
    loginPost: function loginPost(name) {
      this.$router.push({ name: 'Index' });
    }
  }

});

/***/ }),
/* 27 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Query_vue__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Query_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Query_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_List_vue__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_List_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_List_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Add_vue__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Add_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_Add_vue__);
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    Query: __WEBPACK_IMPORTED_MODULE_0__components_Query_vue___default.a,
    List: __WEBPACK_IMPORTED_MODULE_1__components_List_vue___default.a,
    Add: __WEBPACK_IMPORTED_MODULE_2__components_Add_vue___default.a
  },
  data: function data() {
    var _this = this;

    return {
      modal10: true,
      tableData1: this.mockTableData1(),
      tableColumns1: [{
        title: '名称',
        key: 'name'
      }, {
        title: '状态',
        key: 'status',
        render: function render(h, params) {
          var row = params.row;
          var color = row.status === 1 ? 'blue' : row.status === 2 ? 'green' : 'red';
          var text = row.status === 1 ? '构建中' : row.status === 2 ? '构建完成' : '构建失败';

          return h('Tag', {
            props: {
              type: 'dot',
              color: color
            }
          }, text);
        }
      }, {
        title: '画像内容',
        key: 'portrayal',
        render: function render(h, params) {
          return h('Poptip', {
            props: {
              trigger: 'hover',
              title: params.row.portrayal.length + '个画像',
              placement: 'bottom'
            }
          }, [h('Tag', params.row.portrayal.length), h('div', {
            slot: 'content'
          }, [h('ul', _this.tableData1[params.index].portrayal.map(function (item) {
            return h('li', {
              style: {
                textAlign: 'center',
                padding: '4px'
              }
            }, item);
          }))])]);
        }
      }, {
        title: '选定人群数',
        key: 'people',
        render: function render(h, params) {
          return h('Poptip', {
            props: {
              trigger: 'hover',
              title: params.row.people.length + '个客群',
              placement: 'bottom'
            }
          }, [h('Tag', params.row.people.length), h('div', {
            slot: 'content'
          }, [h('ul', _this.tableData1[params.index].people.map(function (item) {
            return h('li', {
              style: {
                textAlign: 'center',
                padding: '4px'
              }
            }, item.n + '：' + item.c + '人');
          }))])]);
        }
      }, {
        title: '取样时段',
        key: 'time',
        render: function render(h, params) {
          return h('div', '近' + params.row.time + '天');
        }
      }, {
        title: '更新时间',
        key: 'update',
        render: function render(h, params) {
          return h('div', _this.formatDate(_this.tableData1[params.index].update));
        }
      }]
    };
  },

  methods: {
    mockTableData1: function mockTableData1() {
      var data = [];
      for (var i = 0; i < 5; i++) {
        data.push({
          name: '商圈' + Math.floor(Math.random() * 100 + 1),
          status: Math.floor(Math.random() * 3 + 1),
          portrayal: ['城市渗透', '人群迁移', '消费指数', '生活指数', '娱乐指数'],
          people: [{
            n: '客群' + Math.floor(Math.random() * 100 + 1),
            c: Math.floor(Math.random() * 1000000 + 100000)
          }, {
            n: '客群' + Math.floor(Math.random() * 100 + 1),
            c: Math.floor(Math.random() * 1000000 + 100000)
          }, {
            n: '客群' + Math.floor(Math.random() * 100 + 1),
            c: Math.floor(Math.random() * 1000000 + 100000)
          }],
          time: Math.floor(Math.random() * 7 + 1),
          update: new Date()
        });
      }
      return data;
    },
    formatDate: function formatDate(date) {
      var y = date.getFullYear();
      var m = date.getMonth() + 1;
      m = m < 10 ? '0' + m : m;
      var d = date.getDate();
      d = d < 10 ? '0' + d : d;
      return y + '-' + m + '-' + d;
    },
    changePage: function changePage() {
      // 这里直接更改了模拟的数据，真实使用场景应该从服务端获取数据
      this.tableData1 = this.mockTableData1();
    }
  }
});

/***/ }),
/* 28 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      formItem: {
        input: '',
        select: '',
        radio: 'male',
        checkbox: [],
        switch: true,
        date: '',
        time: '',
        slider: [20, 50],
        textarea: ''
      }
    };
  }
});

/***/ }),
/* 29 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    var _this = this;

    return {
      tableData1: this.mockTableData1(),
      tableColumns1: [{
        title: '名称',
        key: 'name'
      }, {
        title: '状态',
        key: 'status',
        render: function render(h, params) {
          var row = params.row;
          var color = row.status === 1 ? 'blue' : row.status === 2 ? 'green' : 'red';
          var text = row.status === 1 ? '构建中' : row.status === 2 ? '构建完成' : '构建失败';

          return h('Tag', {
            props: {
              type: 'dot',
              color: color
            }
          }, text);
        }
      }, {
        title: '画像内容',
        key: 'portrayal',
        render: function render(h, params) {
          return h('Poptip', {
            props: {
              trigger: 'hover',
              title: params.row.portrayal.length + '个画像',
              placement: 'bottom'
            }
          }, [h('Tag', params.row.portrayal.length), h('div', {
            slot: 'content'
          }, [h('ul', _this.tableData1[params.index].portrayal.map(function (item) {
            return h('li', {
              style: {
                textAlign: 'center',
                padding: '4px'
              }
            }, item);
          }))])]);
        }
      }, {
        title: '选定人群数',
        key: 'people',
        render: function render(h, params) {
          return h('Poptip', {
            props: {
              trigger: 'hover',
              title: params.row.people.length + '个客群',
              placement: 'bottom'
            }
          }, [h('Tag', params.row.people.length), h('div', {
            slot: 'content'
          }, [h('ul', _this.tableData1[params.index].people.map(function (item) {
            return h('li', {
              style: {
                textAlign: 'center',
                padding: '4px'
              }
            }, item.n + '：' + item.c + '人');
          }))])]);
        }
      }, {
        title: '取样时段',
        key: 'time',
        render: function render(h, params) {
          return h('div', '近' + params.row.time + '天');
        }
      }, {
        title: '更新时间',
        key: 'update',
        render: function render(h, params) {
          return h('div', _this.formatDate(_this.tableData1[params.index].update));
        }
      }]
    };
  },

  methods: {
    mockTableData1: function mockTableData1() {
      var data = [];
      for (var i = 0; i < 5; i++) {
        data.push({
          name: '商圈' + Math.floor(Math.random() * 100 + 1),
          status: Math.floor(Math.random() * 3 + 1),
          portrayal: ['城市渗透', '人群迁移', '消费指数', '生活指数', '娱乐指数'],
          people: [{
            n: '客群' + Math.floor(Math.random() * 100 + 1),
            c: Math.floor(Math.random() * 1000000 + 100000)
          }, {
            n: '客群' + Math.floor(Math.random() * 100 + 1),
            c: Math.floor(Math.random() * 1000000 + 100000)
          }, {
            n: '客群' + Math.floor(Math.random() * 100 + 1),
            c: Math.floor(Math.random() * 1000000 + 100000)
          }],
          time: Math.floor(Math.random() * 7 + 1),
          update: new Date()
        });
      }
      return data;
    },
    formatDate: function formatDate(date) {
      var y = date.getFullYear();
      var m = date.getMonth() + 1;
      m = m < 10 ? '0' + m : m;
      var d = date.getDate();
      d = d < 10 ? '0' + d : d;
      return y + '-' + m + '-' + d;
    },
    changePage: function changePage() {
      // 这里直接更改了模拟的数据，真实使用场景应该从服务端获取数据
      this.tableData1 = this.mockTableData1();
    }
  }
});

/***/ }),
/* 30 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      cityList: [{
        value: 'beijing',
        label: '北京市'
      }, {
        value: 'shanghai',
        label: '上海市'
      }, {
        value: 'shenzhen',
        label: '深圳市'
      }, {
        value: 'hangzhou',
        label: '杭州市'
      }, {
        value: 'nanjing',
        label: '南京市'
      }, {
        value: 'chongqing',
        label: '重庆市'
      }],
      model1: ''
    };
  }
});

/***/ }),
/* 31 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__App__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_iview__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_iview___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_iview__);
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.





__webpack_require__(4);

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].config.productionTip = false;

__WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */].beforeEach(function (to, from, next) {
  __WEBPACK_IMPORTED_MODULE_3_iview___default.a.LoadingBar.start();
  next();
});

__WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */].afterEach(function (to, from, next) {
  __WEBPACK_IMPORTED_MODULE_3_iview___default.a.LoadingBar.finish();
});

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_3_iview___default.a);
/* eslint-disable no-new */
new __WEBPACK_IMPORTED_MODULE_0_vue__["default"]({
  el: '#app',
  router: __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */],
  template: '<App/>',
  components: { App: __WEBPACK_IMPORTED_MODULE_1__App___default.a }
});

/***/ })
],[31]);


// WEBPACK FOOTER //
// static/js/app.713de3ea4f60a3e6c9ad.js